import { Button } from '@wellesley/ui'
import { AlignJustify } from 'lucide-react'
import { FC } from 'react'

export type HeaderBurgerProps = {
  onToggleSidebar?: () => void
  className?: string
}

const HeaderBurger: FC<HeaderBurgerProps> = ({
  onToggleSidebar,
  className,
}) => {
  return (
    <Button
      aria-label="Toggle sidebar"
      data-testid="header-burger"
      variant="secondary"
      size="icon_m"
      type="button"
      onClick={onToggleSidebar}
      className={className}
    >
      <AlignJustify />
    </Button>
  )
}

export default HeaderBurger
